import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'hr-form-array-shimmer',
    templateUrl: './hr-form-array-shimmer.component.html',
})
export class HrFormArrayShimmerComponent implements OnInit {
    @Input() numberOfParameter: number = 1;
    constructor() {}

    ngOnInit(): void {}

    getEmptyArrayWithSize() {
        return new Array(this.numberOfParameter);
    }
}
